import script from "./PlaceDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaceDetails.vue?vue&type=script&setup=true&lang=ts"

import "./PlaceDetails.vue?vue&type=style&index=0&id=de1c3dba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de1c3dba"]])

export default __exports__